module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ai708-321db9759bbb7c1d3cfc5d740a04c105.jpg";